/// <reference types="@types/google.maps" />

import { CountryCode, GooglePlaceTypeFilter } from "@zickko/shared";
import React, { useEffect } from "react";

type Props = {
  onChange: (value: google.maps.places.PlaceResult) => void;
  typeFilter: keyof typeof GooglePlaceTypeFilter;
  country?: CountryCode;
  currentLocation?: string;
};

export const GooglePlaceAutocompleteInput = (props: Props) => {
  //
  let textInput: React.RefObject<HTMLInputElement> = React.createRef<HTMLInputElement>();

  const initAutocomplete = (): void => {
    const { country } = props;

    if (!textInput.current) return;

    const autocomplete = new google.maps.places.Autocomplete(textInput.current, {
      componentRestrictions: country ? { country } : undefined,
      types: GooglePlaceTypeFilter[props.typeFilter],
    });

    google.maps.event.addListener(autocomplete, "place_changed", () => {
      if (!textInput.current) return;

      const placeResult = autocomplete.getPlace();
      if (!placeResult) return;
      props.onChange(placeResult);
    });
  };

  useEffect(() => {
    initAutocomplete();
  });

  return <input type="text" ref={textInput} />;
  // return <Search type="text" ref={textInput} labelText="" placeholder={props.currentLocation} />;
};
